import AddTask from "./components/addTask";
import "./App.css";
import { v4 as uuidv4 } from "uuid";
import {
  addOneDoc,
  readAllDocs,
  getSomeDocs,
  modifyOneDoc,
  deleteOneDoc,
} from "./utilities/firebase";
import { useEffect, useState } from "react";
import Sidebar from "./components/sidebar";
import Main from "./components/main";

const testProjects = [
  { name: "Default", id: "1" },
  { name: "Green Presentation", id: "2" },
  { name: "Car Repair", id: "3" },
  { name: "Home Gym", id: "4" },
  { name: "Vegetable Garden", id: "5" },
];

function App() {
  const [tasks, setTasks] = useState([]);
  const [filterCat, setFilterCat] = useState("next");
  const [editTaskId, setEditTaskId] = useState();
  const [showModal, setShowModal] = useState(false);
  const [projects, setProjects] = useState(testProjects);

  console.log({ editTaskId });

  function renderTasks() {
    readAllDocs().then((data) => {
      setTasks(data);
    });
  }

  // tasks.forEach((task) => addOneDoc(task.id, task));

  // readAllDocs()
  // .then(data => {
  //   console.log(data)
  //   data.forEach(item => console.log(item.task))
  // })

  // getSomeDocs("next")
  // console.log(uuidv4())

  // modifyOneDoc("5", {
  //       id: "5",
  //       task: "Make presentation on Coal energy",
  //       category: "someday",
  //       status: false,
  //       tags :["work", "email"],
  //       date: null,
  //       project: {name: "default", priority: null},
  //       note: "Include all energy options internationally available",
  //       userId: "007",
  //       createdOn: "timestamp"
  //   })

  // deleteOneDoc("5")

  // addOneDoc("5", {
  //       id: "5",
  //       task: "Make presentation on Coal energy",
  //       category: "someday",
  //       status: false,
  //       tags :["work", "email"],
  //       date: null,
  //       project: {name: "default", priority: null},
  //       note: "Include all energy options internationally available",
  //       userId: "007",
  //       createdOn: "timestamp"
  //   })

  useEffect(() => {
    readAllDocs().then((data) => {
      // console.log(data)
      // data.forEach(item => console.log(item.task))
      setTasks(data);
    });
  }, []);

  return (
    <>
      <header className="head">
        <svg viewBox="0 0 512 512" width="30" height="30" title="tasks">
          <path d="M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z" />
        </svg>
        <h1>Tasker</h1>
      </header>

      <section className="content">
        <Sidebar
          setFilterCat={setFilterCat}
          projects={projects}
          setProjects={setProjects}
        />
        <Main
          tasks={tasks}
          filterCat={filterCat}
          renderTasks={renderTasks}
          setEditTaskId={setEditTaskId}
          showModal={showModal}
          setShowModal={setShowModal}
        />
      </section>

      <AddTask
        tasks={tasks}
        setTasks={setTasks}
        editTaskId={editTaskId}
        setEditTaskId={setEditTaskId}
        renderTasks={renderTasks}
        showModal={showModal}
        setShowModal={setShowModal}
        projects={projects}
      />
    </>
  );
}

export default App;
